import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-navlist', 'MY_SHORTCUTS', 'Minu kiirmenüü');
Labels.set('ui-navlist', 'REMOVE_SHORTCUT', 'Kustuta kiirvalikust');
Labels.set('ui-navlist', 'ADD_SHORTCUT', 'Lisa kiirvalikusse');
Labels.set('ui-navlist', 'EDIT_SHORTCUTS', 'Muuda kiirvalikuid');
Labels.set('ui-navlist', 'FINISH_EDITING', 'Lõpeta muutmine');
Labels.set('ui-navlist', 'BACK', 'Tagasi');
